import { ReactNode } from 'react';

import {
  RecommendationCard,
  RecommendationCardProps,
} from '@/decodo/blocks/RecommendationCards/RecommendationCard';
import { LinkButtonStrapiProps } from '@/decodo/components/atoms/LinkButton/LinkStrapi';
import { FeatureListStrapiProps } from '@/decodo/features/FeatureListStrapi/FeatureListStrapiDC';
import { cn } from '@/lib/utils';

export type RecommendationCard = {
  icon?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  features: FeatureListStrapiProps;
  description: ReactNode;
  cta: LinkButtonStrapiProps;
  isRecommended?: boolean;
};

type RecommendationCardsProps = {
  cards: RecommendationCardProps[];
};

export const RecommendationCards = ({ cards }: RecommendationCardsProps) => {
  const hasRecommendedCards = cards.some(
    (card) => !!card.isRecommended === true
  );
  return (
    <div
      className={cn(
        'grid grid-cols-1 place-content-end gap-y-8 md:gap-y-12 lg:grid-cols-2 lg:gap-12',
        hasRecommendedCards && 'lg:mt-8',
        hasRecommendedCards && 'mt-8 gap-y-8 md:gap-y-12',
        hasRecommendedCards && 'gap-y-16 md:gap-y-20'
      )}
    >
      {cards.map((card) => (
        <RecommendationCard
          key={card.title}
          {...card}
          isRecommended={card.isRecommended}
        />
      ))}
    </div>
  );
};
